import React from 'react'

import { Icon } from 'components/Icon'
import { Select } from 'components/Select/Select'

interface Props {
  state: { pageIndex: number; pageSize: number }
  setPageSize: (size: number) => void
  pageOptions: []
  previousPage: () => void
  nextPage: () => void
  canNextPage: boolean
  canPreviousPage: boolean
  pagination: {
    mainLabel?: string
  }
}

const Pagination: React.FC<Props> = ({
  state: { pageIndex },
  setPageSize,
  pageOptions,
  previousPage,
  nextPage,
  canNextPage,
  canPreviousPage,
  pagination,
}) => {
  return (
    <div className="flex items-center self-end pagination gap-x-7">
      <div className="flex items-center gap-x-3">
        <span>{pagination?.mainLabel || ''}</span>
        <Select
          onUserSelect={(e) => setPageSize(Number(e))}
          options={[
            {
              id: '10',
              value: '10',
            },
            {
              id: '20',
              value: '20',
            },
            {
              id: '30',
              value: '30',
            },
            {
              id: '40',
              value: '40',
            },
            {
              id: '50',
              value: '50',
            },
          ]}
          selectName="selectRowPerPage"
          id="selectRowPerPage"
          placeholder="10"
        />
        <span>
          {pageIndex + 1} of {pageOptions.length}
        </span>
      </div>
      <div className="flex items-center gap-x-3">
        <button
          className={`${
            !canPreviousPage
              ? 'text-gray hover:cursor-default'
              : 'text-flamingo'
          } flex items-center font-semibold gap-x-1 `}
          onClick={() => previousPage()}
          disabled={!canPreviousPage}
        >
          <Icon
            className={`${!canPreviousPage ? 'text-gray' : 'text-flamingo'}`}
            icon="chevron-left-2"
            iconSize={20}
          />
          Pre
        </button>{' '}
        <button
          className={`${
            !canNextPage ? 'text-gray hover:cursor-default' : 'text-flamingo'
          } flex items-center font-semibold gap-x-1`}
          onClick={() => nextPage()}
          disabled={!canNextPage}
        >
          Next
          <Icon
            className={`${!canNextPage ? 'text-gray' : 'text-flamingo'} `}
            icon="chevron-right"
            iconSize={20}
          />
        </button>{' '}
      </div>
    </div>
  )
}

export default Pagination
